module.exports = __webpack_public_path__ + "assets/portrait-icon-note-white.d61159a2.svg";